import React from 'react';
import Tariffs from '../components/Tariffs';

const TariffsPage: React.FC = () => {
  return (
    <div style={{ }}>
      <Tariffs />
    </div>
  );
};

export default TariffsPage;